import { useQuery } from '@apollo/client'
import { Sublocations } from '../../types'
import { SUB_LOCATION } from './operations'

export const useSublocation = () => useQuery<Sublocations>(SUB_LOCATION)
